import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import PersonIcon from '@mui/icons-material/Person';
import CountrySelect from '../../components/CountrySelect';
import MeProfile from './MeProfile';

export default function Me() {
  const { t } = useTranslation();

  const [signedIn, setSignedIn] = useState(false);
  const [countryCode, setCountryCode] = useState('US');
  const [publicId, setPublicId] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('signedIn');
    if (saved) {
      const { countryCode: cc, publicId: pid } = JSON.parse(saved);
      setCountryCode(cc);
      setPublicId(pid);
      setSignedIn(true);
    }
  }, []);

  useEffect(() => {
    if (signedIn && countryCode && publicId) {
      localStorage.setItem('signedIn', JSON.stringify({ countryCode, publicId }));
    }
  }, [signedIn, countryCode, publicId]);

  const handleLogout = () => {
    localStorage.removeItem('signedIn');
    setSignedIn(false);
  };

  if (signedIn) {
    return <MeProfile publicId={`${countryCode}|${publicId}`} onLogout={handleLogout} />;
  }

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      minHeight: 'calc(100vh - 56px)', bgcolor: '#f5f5f5',
    }}>
      {/* Hero header */}
      <Box sx={{
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
        color: 'white',
        px: 2, pt: 4, pb: 5,
        textAlign: 'center',
      }}>
        <Box sx={{
          width: 80, height: 80, borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          mx: 'auto', mb: 2,
        }}>
          <PersonIcon sx={{ color: 'white', fontSize: 40 }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {t('app.meSignInTitle')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mt: 0.5 }}>
          {t('app.meSignInSubtitle')}
        </Typography>
      </Box>

      {/* Sign in card */}
      <Box sx={{ px: 1.5, mt: -2.5 }}>
        <Paper sx={{ p: 3, borderRadius: 2.5 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2.5, textAlign: 'center' }}>
            {t('app.meSignInDescription')}
          </Typography>

          <CountrySelect
            value={countryCode}
            onChange={setCountryCode}
            label={t('app.meCountry')}
            size="small"
            sx={{ mb: 2 }}
          />
          <TextField
            label={t('app.meShooterId')}
            value={publicId}
            onChange={(e) => setPublicId(e.target.value)}
            size="small"
            fullWidth
            sx={{ mb: 2.5 }}
          />

          <Button
            variant="contained"
            disabled={!publicId}
            onClick={() => setSignedIn(true)}
            fullWidth
            sx={{ borderRadius: 2.5, py: 1.5, textTransform: 'none', fontWeight: 600 }}
          >
            {t('app.meSignIn')}
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
